import React from 'react'
import { CowboyCountProvider } from '@/contexts/CowboyCountContext'

interface CowboyUpLayoutProps {
  children: React.ReactNode
}

export const CowboyUpLayout: React.FC<CowboyUpLayoutProps> = ({ children }) => {
  return <CowboyCountProvider>{children}</CowboyCountProvider>
}

export default CowboyUpLayout
